import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Video from '../Video';

class CourseVideoTabs extends Component {
  constructor (props) {
    super(props);
    this.tabClickHandler = this.tabClickHandler.bind(this);
    this.state = {
      activeTab: 'intro'
    };
  }
  tabClickHandler (tab) {
    this.setState(
      {
        activeTab: tab
      }
    );
  }
  render () {
    const listItems = [
      <li><a onClick={(e) => this.tabClickHandler('intro', e)} className={this.state.activeTab === 'intro' ? 'is-active' : ''}>Introduction video</a></li>
    ];
    if (this.props.sampleVideo != null) {
      listItems[1] = <li><a onClick={(e) => this.tabClickHandler('sample', e)} className={this.state.activeTab === 'sample' ? 'is-active' : ''}>Sample class</a></li>
    }
    return (
      <section className='tabs'>
        <nav>
          <ul className='tabs__nav'>
            {listItems}
          </ul>
        </nav>
        <div className={'tabs__item is-checked ' + (this.state.activeTab === 'intro' ? 'is-checked is-active' : '')}>
          <div className='video-container'>
            <div className='video-container__inner'>
              <Video embedCode={this.props.introVideo}
                width={598}
                height={336}
              />
            </div>
          </div>
        </div>
        <div className={'tabs__item ' + (this.state.activeTab === 'sample' ? 'is-checked is-active' : '')}>
          <div className='video-container'>
            <div className='video-container__inner'>
              <Video embedCode={this.props.sampleVideo}
                width={598}
                height={336}
              />
            </div>
          </div>
        </div>
      </section>
    );
  }
}

CourseVideoTabs.propTypes = {
  introVideo: PropTypes.string,
  sampleVideo: PropTypes.string
};

export default CourseVideoTabs;



// WEBPACK FOOTER //
// ./src/components/CourseVideoTabs/index.js